// extracted by mini-css-extract-plugin
module.exports = {"scmSingleSimulationNotification":"SingleNotificationWrapper_scmSingleSimulationNotification__3V9E7"};